import { Injectable } from '@angular/core';
import { User } from '../models/interfaces/user.interface';

@Injectable({ providedIn: 'root' })
export class SelectedUserUtil {

  private userSelected: User | undefined;

  public setSelectedUser(user: User){
    this.userSelected = user;
  }

  public getSelectedUser() {
    return this.userSelected;
  }

  public clearSelectedUser(){
    this.userSelected = undefined
  }

}
